import { useState } from 'react';

export const useQuestions = () => {
  const [filters, setFilters] = useState<{ [key: string]: any }>({});
  const [appliedFilters, setAppliedFilters] = useState<{ [key: string]: any }>(
    {},
  );
  const [searchQuery, setSearchQuery] = useState('');

  // Handle search query update
  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  // Apply selected filters
  const handleApplyFilters = (selectedFilters: { [key: string]: any }) => {
    setFilters(selectedFilters);
    setAppliedFilters(selectedFilters);
  };

  // Remove individual filter
  const handleRemoveFilter = (key: string, value: any) => {
    setAppliedFilters((prev) => {
      const updatedFilters = { ...prev };
      updatedFilters[key] = updatedFilters[key].filter(
        (item: any) => item !== value,
      );
      if (updatedFilters[key].length === 0) delete updatedFilters[key];
      return updatedFilters;
    });
    setFilters((prev) => {
      const updatedFilters = { ...prev };
      updatedFilters[key] = updatedFilters[key].filter(
        (item: any) => item !== value,
      );
      if (updatedFilters[key].length === 0) delete updatedFilters[key];
      return updatedFilters;
    });
  };

  // Clear all filters
  const handleClearFilters = () => {
    setFilters({});
    setAppliedFilters({});
  };

  return {
    searchQuery,
    handleSearch,
    handleApplyFilters,
    handleRemoveFilter,
    handleClearFilters,
    filters,
    appliedFilters,
  };
};
